import { Canvas, useLoader } from '@react-three/fiber';
import { useRef, useEffect } from 'react';
import { TextureLoader } from 'three/src/loaders/TextureLoader';
import { OrbitControls } from '@react-three/drei';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './style.module.scss';
import Projects from './games';

gsap.registerPlugin(ScrollTrigger);

export default function Earth() {
    const container = useRef(null);
    const mesh = useRef(null);

    useEffect(() => {
        const context = gsap.context(() => {
            ScrollTrigger.create({
                trigger: container.current,
                start: 'top top',
                end: 'bottom bottom',
                scrub: 0.5, 
                onUpdate: (self) => {
                    gsap.to(mesh.current.rotation, {
                        y: self.progress * Math.PI * 2 * 0.5, //rotating horizontally with a slower speed
                        ease: 'power3.out',
                        overwrite: 'auto'
                    });
                }
            });
        }, container);

        return () => context.revert();
    }, []);

    return (
        <div ref={container} className={styles.modelContainer}>
            <Canvas>
                <OrbitControls enableZoom={false} enablePan={false} />
                <ambientLight intensity={0.1} />
                <directionalLight intensity={3.5} position={[1, 0, -0.25]} />
                <EarthModel meshRef={mesh} />
            </Canvas>
            <Projects />
        </div>
    );
}

function EarthModel({ meshRef }) {
    const [color, normal, aoMap] = useLoader(TextureLoader, [
        '/assets/color.jpg',
        '/assets/normal.png',
        '/assets/occlusion.jpg'
    ]);

    return (
        <mesh ref={meshRef} scale={2.5}>
            <sphereGeometry args={[1, 64, 64]} />
            <meshStandardMaterial map={color} normalMap={normal} aoMap={aoMap} />
        </mesh>
    );
}
